import { gql } from '@apollo/client'

/**
 * GraphQL query to get product family and product type auto-suggestions.
 *
 * This query supports searching for both families and product types
 * depending on the input parameters.
 */
export const GetPplFamilyAndPtAutoSuggest = gql`
    query getPPLFamilyAndPTAutoSuggest($input: PPLFamilyAutosuggestInput!) {
        getPPLFamilyAndPTAutoSuggest(input: $input) {
            result
        }
    }
`

/**
 * Input parameters for the PPL family and product type auto-suggest query
 */
export interface PPLFamilyAndPTAutoSuggestInput {
    searchText: string
    maxResults: number
    /** Whether to search for product types (true) or families (false) */
    searchProductTypes: boolean
    /** Optional family name when searching for product types within a specific family */
    productFamilyName?: string
}

/**
 * Result structure for the PPL family and product type auto-suggest query
 */
export interface PPLFamilyAndPTAutoSuggestResult {
    getPPLFamilyAndPTAutoSuggest: {
        result: string[]
    }
}

/**
 * GraphQL query to get product family property keys.
 */
export const GetProductFamilyPropertyKeys = gql`
    query getProductFamilyPropertyKeys($input: GetProductFamilyKeyInput!) {
        getProductFamilyPropertyKeys(input: $input) {
            productFamilyPropertyKeys {
                contentItemId
                elementId
                keyText
            }
            productFamilyId
            familyNumber
        }
    }
`

/**
 * Input parameters for the product family property keys query
 */
export interface ProductFamilyPropertyKeysInput {
    familyNumber: string
    familyName: string
}

/**
 * Result structure for the product family property keys query
 */
export interface ProductFamilyPropertyKeysResult {
    getProductFamilyPropertyKeys: {
        productFamilyPropertyKeys: Array<{
            contentItemId: string
            elementId: string
            keyText: string
        }>
        productFamilyId: string
        familyNumber: string
    }
}
